import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RightPanel from '../RightPanel';
import Search from '../Search';
import { useSelector } from 'react-redux';
import { ApplicationShell } from '../index';
import '../../Sass/theme.scss';
import {
  selectAuthProfiles,
  selectAuthIsFetching,
} from '../../redux/selectors/authSelectors';
import { selectCveFields } from '../../redux/selectors/cveFieldsSelectors';

const MainLayout = () => {
  const profiles = useSelector(selectAuthProfiles);
  const isFetching = useSelector(selectAuthIsFetching);
  const cveFields = useSelector(selectCveFields);
  const location = useLocation();
  const [searchState, setSearchState] = useState(null);
  
  return (
    <ApplicationShell>
      <ToastContainer />
      {isFetching && (
        <div className='pagepreloader-wrapper'>
          <div className='preloader'></div>
          <div className='pageoverlay'></div>
        </div>
      )}
      <div className='header'>
        <Row>
          <Col>
            <div className='content content-full-width'>
              <div className='profile-header'></div>
            </div>
          </Col>
        </Row>
      </div>
      <Row className='g-0'>
        <Col md={10} className='DivMain'>
          {profiles ? (
            <>
              {location.pathname !== '/advanced-search' ? <Search setSearchState={setSearchState} /> : null}
              <Outlet context={{ searchState }} />
            </>
          ) : null}
        </Col> 
        <Col md={2} className='DivRight'>
          {profiles && profiles.cve ? (
            <RightPanel
              profiles={profiles}
              path={location.pathname}
              cveFields={cveFields}
            />
          ) : null}
        </Col>
      </Row>
    </ApplicationShell>
  );
};

export default MainLayout;
